<kendo-breadcrumb
    [items]="items"
    (itemClick)="itemClick($event)"
>
</kendo-breadcrumb>
